import * as React from 'react'
import { observer } from 'mobx-react'
import UnarchiveItemViewModel from './UnarchiveItemViewModel'
import { useBrandingSettings } from 'hooks/branding'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './UnarchiveItemModal.sass'

interface Props {
  vm: UnarchiveItemViewModel
}

export default observer(function UnarchiveItemDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  const workspaceName = vm.inventoryItem?.workspace?.name
  const inventoryItemName = vm.inventoryItem?.name
  const inventoryItemNameLength = inventoryItemName?.length ?? 0
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="inventory-items-close-unarchive-modal" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_job-completed.svg')}
              alt="Unarchive item"
            />
          )}
          <h3 className={styles.title}>
            {vm.inventoryItem?.override ? (
              <>
                You are about to unarchive this override of <br />
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            ) : (
              <>
                You are about to unarchive{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            )}
          </h3>
          <p className={styles.description}>
            {vm.inventoryItem?.override ? (
              'All legends in ' +
              (workspaceName !== undefined ? workspaceName : 'this workspace') +
              ' will need to be updated to reference the global version of this item.'
            ) : (
              <>
                All legends will be able to reference this service item.
                Existing legends can also be updated to utilize this service
                item.
              </>
            )}
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            disabled={vm.unarchive.pending}
            onClick={vm.close}
            type="default"
          >
            Cancel
          </Button>
          <Button
            onClick={vm.unarchive}
            loading={vm.unarchive.pending}
            disabled={vm.unarchive.pending}
            type="primary"
            dataTest="inventory-items-unarchive-button"
          >
            Unarchive
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
